import { VERSION } from '../version';
export const queryServerStyleTag = (name, additionalAttributes = [])=>{
    var _document_querySelector;
    return (_document_querySelector = document.querySelector(`style[data-layer="${name}"][data-server="${VERSION}"]${additionalAttributes.map((attr)=>`[${attr}]`)}`)) !== null && _document_querySelector !== void 0 ? _document_querySelector : undefined;
};

//# sourceMappingURL=queryServerStyleTag.js.map